export * as Theming from "./Theming";

// generate a hash code from a string
// see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
export const getHash = (text: string): number => {
    let hash = 0;

    for (let i = 0, len = text.length; i < len; i++) {
        let chr = text.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // convert to 32-bit integer
    }

    return hash;
};

// classNames utility function
export const classNames = (classes: (string | null | boolean)[]): string => {
    const css = classes.filter(value => !(value == null || value === "" || !value));
    return css.join(" ").trim();
};

export const parseClasses = (classes: string | string[] | undefined): string => {
    if (!classes) {
        return "";
    }

    const css = classes ? (Array.isArray(classes) ? [...classes].join(" ") : classes) : "";
    return css;
};


export const getNaturalLanguageList = (a: (number | string)[]): string => {
    return a.reduce((prev, curr, idx) => {
        if (a.length === 2) {
            return [prev, " and ", curr].join("");
        }

        if (idx === a.length - 1) {
            return [prev, ", and ", curr].join("");
        }

        return [prev, ", ", curr].join("");
    }) as string;
};